import React from "react";
import dayjs from "dayjs";
import { BackIcon, Container } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import {
  BoldHeading,
  HorizontalLeftAlign,
  RegLg,
  VerticalAlign,
} from "../../../../Components/CustomStyles";
import ClipLoader from "react-spinners/ClipLoader";
import Colors from "../../../../Constant/Colors";

const QuizDetails = ({ handleView, course }) => {
  const { quizLoading, quizDetails } = useSelector(state => state.home)
  const handleBackBtn = () => {
    if (course?.id) {
      handleView("courseMaterial", course);
    } else {
      handleView("list");
    }
  };


  return (
    <Container>
      <HorizontalLeftAlign style={{ marginTop: 10, marginBottom: 10 }}>
        <BackIcon onClick={handleBackBtn} style={{ marginBottom: -8 }}>
          <KeyboardBackspaceIcon />
        </BackIcon>
        <BoldHeading style={{ textTransform: "capitalize" }}>
          {course?.quiz ?? ''}{' - Quiz Details'}
        </BoldHeading>
      </HorizontalLeftAlign>

      {
        quizLoading ?
          <VerticalAlign style={{ height: 100 }}>
            <ClipLoader color={Colors.primary} size={20} />
          </VerticalAlign> :

          <>
            <HorizontalLeftAlign style={{ width: '100%', backgroundColor: '#6662', padding: 5, }}>
              <BoldHeading style={{ width: '40%' }}>Student</BoldHeading>
              <BoldHeading style={{ width: '50%' }}>Submitted at</BoldHeading>
              <BoldHeading style={{ width: '10%' }}>Score</BoldHeading>
            </HorizontalLeftAlign>

            <div style={{ marginTop: 20 }}>{
              quizDetails?.length ?
                quizDetails.map((quiz, ind) => (
                  <HorizontalLeftAlign style={{ width: '100%', marginBottom: 10, paddingLeft:10 }}>
                    <RegLg style={{ width: '40%'}}>{quiz?.student?.first_name}</RegLg>
                    <RegLg style={{ width: '50%' }}>{quiz?.submit_at ? dayjs(quiz?.submit_at).format('MMM DD, YY') : 'Not submitted'}</RegLg>
                    <RegLg style={{ width: '10%' }}>{quiz?.score !== null ? `${quiz?.score}%` : '-'}</RegLg>
                  </HorizontalLeftAlign>

                )) : <></>
            }</div>
          </>

      }



    </Container>
  );
};

export default QuizDetails;
